export const chatTranslations = {
  en: {
    chat: {
      title: "Finn - Your AI Financial Advisor",
      subtitle: "Get personalized financial advice with Finn, our intelligent assistant. Specialized in personal finance, investments, and economic planning.",
      meta: {
        title: "Finn - Your AI Financial Advisor - Finanzly",
        description: "Chat with Finn, our intelligent financial advisor. Get personalized advice on investments, savings, budgets, and financial planning.",
        keywords: "Finn, financial advisor, artificial intelligence, chat, personal finance, financial advice, investments, savings"
      },
      features: {
        personalized: {
          title: "Personalized Advice",
          description: "Receive recommendations tailored to your specific financial situation"
        },
        planning: {
          title: "Smart Planning",
          description: "Investment and savings strategies based on best practices"
        },
        security: {
          title: "Secure Information",
          description: "Your conversations are private and we don't store personal information"
        }
      },
      disclaimer: {
        title: "Important Notice:",
        content: "The information provided is for educational purposes only and does not constitute professional financial advice. Always consult with a certified financial advisor before making important investment decisions."
      },
      input: {
        placeholder: "Ask Finn about your finances...",
        send: "Send"
      },
      container: {
        expertTitle: "Your personal finance expert",
        welcome: "Hello! I'm Finn, your financial advisor",
        welcomeMessage: "I'm here to help you with all your questions about personal finance, investments, savings, and financial planning. How can I help you today?"
      },
      errors: {
        unknown: "Unknown error",
        network: "Network error. Please check your connection.",
        server: "Server error. Please try again later."
      }
    }
  },
  es: {
    chat: {
      title: "Finn - Tu Asesor Financiero IA",
      subtitle: "Obtén consejos financieros personalizados con Finn, nuestro asistente inteligente. Especializado en finanzas personales, inversiones y planificación económica.",
      meta: {
        title: "Finn - Tu Asesor Financiero IA - Finanzly",
        description: "Chatea con Finn, nuestro asesor financiero inteligente. Obtén consejos personalizados sobre inversiones, ahorro, presupuestos y planificación financiera.",
        keywords: "Finn, asesor financiero, inteligencia artificial, chat, finanzas personales, consejos financieros, inversiones, ahorro"
      },
      features: {
        personalized: {
          title: "Consejos Personalizados",
          description: "Recibe recomendaciones adaptadas a tu situación financiera específica"
        },
        planning: {
          title: "Planificación Inteligente",
          description: "Estrategias de inversión y ahorro basadas en las mejores prácticas"
        },
        security: {
          title: "Información Segura",
          description: "Tus conversaciones son privadas y no almacenamos información personal"
        }
      },
      disclaimer: {
        title: "Aviso importante:",
        content: "La información proporcionada es únicamente para fines educativos y no constituye asesoramiento financiero profesional. Siempre consulta con un asesor financiero certificado antes de tomar decisiones importantes de inversión."
      },
      input: {
        placeholder: "Pregúntale a Finn sobre tus finanzas...",
        send: "Enviar"
      },
      container: {
        expertTitle: "Tu experto en finanzas personales",
        welcome: "¡Hola! Soy Finn, tu asesor financiero",
        welcomeMessage: "Estoy aquí para ayudarte con todas tus preguntas sobre finanzas personales, inversiones, ahorro y planificación financiera. ¿En qué puedo ayudarte hoy?"
      },
      errors: {
        unknown: "Error desconocido",
        network: "Error de red. Por favor, verifica tu conexión.",
        server: "Error del servidor. Por favor, inténtalo de nuevo más tarde."
      }
    }
  },
  fr: {
    chat: {
      title: "Finn - Votre Conseiller Financier IA",
      subtitle: "Obtenez des conseils financiers personnalisés avec Finn, notre assistant intelligent. Spécialisé en finances personnelles, investissements et planification économique.",
      meta: {
        title: "Finn - Votre Conseiller Financier IA - Finanzly",
        description: "Discutez avec Finn, notre conseiller financier intelligent. Obtenez des conseils personnalisés sur les investissements, l'épargne, les budgets et la planification financière.",
        keywords: "Finn, conseiller financier, intelligence artificielle, chat, finances personnelles, conseils financiers, investissements, épargne"
      },
      features: {
        personalized: {
          title: "Conseils Personnalisés",
          description: "Recevez des recommandations adaptées à votre situation financière spécifique"
        },
        planning: {
          title: "Planification Intelligente",
          description: "Stratégies d'investissement et d'épargne basées sur les meilleures pratiques"
        },
        security: {
          title: "Informations Sécurisées",
          description: "Vos conversations sont privées et nous ne stockons pas d'informations personnelles"
        }
      },
      disclaimer: {
        title: "Avis important:",
        content: "Les informations fournies sont uniquement à des fins éducatives et ne constituent pas des conseils financiers professionnels. Consultez toujours un conseiller financier certifié avant de prendre des décisions d'investissement importantes."
      },
      input: {
        placeholder: "Demandez à Finn à propos de vos finances...",
        send: "Envoyer"
      },
      container: {
        expertTitle: "Votre expert en finances personnelles",
        welcome: "Bonjour ! Je suis Finn, votre conseiller financier",
        welcomeMessage: "Je suis là pour vous aider avec toutes vos questions sur les finances personnelles, les investissements, l'épargne et la planification financière. Comment puis-je vous aider aujourd'hui ?"
      },
      errors: {
        unknown: "Erreur inconnue",
        network: "Erreur réseau. Veuillez vérifier votre connexion.",
        server: "Erreur serveur. Veuillez réessayer plus tard."
      }
    }
  },
  de: {
    chat: {
      title: "Finn - Ihr KI-Finanzberater",
      subtitle: "Erhalten Sie personalisierte Finanzberatung mit Finn, unserem intelligenten Assistenten. Spezialisiert auf persönliche Finanzen, Investitionen und Wirtschaftsplanung.",
      meta: {
        title: "Finn - Ihr KI-Finanzberater - Finanzly",
        description: "Chatten Sie mit Finn, unserem intelligenten Finanzberater. Erhalten Sie personalisierte Beratung zu Investitionen, Ersparnissen, Budgets und Finanzplanung.",
        keywords: "Finn, Finanzberater, künstliche Intelligenz, Chat, persönliche Finanzen, Finanzberatung, Investitionen, Ersparnisse"
      },
      features: {
        personalized: {
          title: "Personalisierte Beratung",
          description: "Erhalten Sie Empfehlungen, die auf Ihre spezifische finanzielle Situation zugeschnitten sind"
        },
        planning: {
          title: "Intelligente Planung",
          description: "Investment- und Sparstrategien basierend auf bewährten Praktiken"
        },
        security: {
          title: "Sichere Informationen",
          description: "Ihre Gespräche sind privat und wir speichern keine persönlichen Informationen"
        }
      },
      disclaimer: {
        title: "Wichtiger Hinweis:",
        content: "Die bereitgestellten Informationen dienen nur zu Bildungszwecken und stellen keine professionelle Finanzberatung dar. Konsultieren Sie immer einen zertifizierten Finanzberater, bevor Sie wichtige Investitionsentscheidungen treffen."
      },
      input: {
        placeholder: "Fragen Sie Finn nach Ihren Finanzen...",
        send: "Senden"
      },
      container: {
        expertTitle: "Ihr Experte für persönliche Finanzen",
        welcome: "Hallo! Ich bin Finn, Ihr Finanzberater",
        welcomeMessage: "Ich bin hier, um Ihnen bei allen Fragen zu persönlichen Finanzen, Investitionen, Ersparnissen und Finanzplanung zu helfen. Wie kann ich Ihnen heute helfen?"
      },
      errors: {
        unknown: "Unbekannter Fehler",
        network: "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
        server: "Serverfehler. Bitte versuchen Sie es später erneut."
      }
    }
  },
  hi: {
    chat: {
      title: "Finn - आपका AI वित्तीय सलाहकार",
      subtitle: "Finn, हमारे बुद्धिमान सहायक के साथ व्यक्तिगत वित्तीय सलाह प्राप्त करें। व्यक्तिगत वित्त, निवेश और आर्थिक योजना में विशेषज्ञ।",
      meta: {
        title: "Finn - आपका AI वित्तीय सलाहकार - Finanzly",
        description: "Finn, हमारे बुद्धिमान वित्तीय सलाहकार के साथ चैट करें। निवेश, बचत, बजट और वित्तीय योजना पर व्यक्तिगत सलाह प्राप्त करें।",
        keywords: "Finn, वित्तीय सलाहकार, कृत्रिम बुद्धिमत्ता, चैट, व्यक्तिगत वित्त, वित्तीय सलाह, निवेश, बचत"
      },
      features: {
        personalized: {
          title: "व्यक्तिगत सलाह",
          description: "अपनी विशिष्ट वित्तीय स्थिति के अनुरूप सिफारिशें प्राप्त करें"
        },
        planning: {
          title: "स्मार्ट योजना",
          description: "सर्वोत्तम प्रथाओं पर आधारित निवेश और बचत रणनीतियाँ"
        },
        security: {
          title: "सुरक्षित जानकारी",
          description: "आपकी बातचीत निजी है और हम व्यक्तिगत जानकारी संग्रहीत नहीं करते"
        }
      },
      disclaimer: {
        title: "महत्वपूर्ण सूचना:",
        content: "प्रदान की गई जानकारी केवल शैक्षिक उद्देश्यों के लिए है और पेशेवर वित्तीय सलाह का गठन नहीं करती है। महत्वपूर्ण निवेश निर्णय लेने से पहले हमेशा एक प्रमाणित वित्तीय सलाहकार से परामर्श करें।"
      },
      input: {
        placeholder: "Finn से अपने वित्त के बारे में पूछें...",
        send: "भेजें"
      },
      container: {
        expertTitle: "आपके व्यक्तिगत वित्त विशेषज्ञ",
        welcome: "नमस्ते! मैं Finn हूँ, आपका वित्तीय सलाहकार",
        welcomeMessage: "मैं व्यक्तिगत वित्त, निवेश, बचत और वित्तीय योजना के बारे में आपके सभी सवालों में मदद के लिए यहाँ हूँ। आज मैं आपकी कैसे मदद कर सकता हूँ?"
      },
      errors: {
        unknown: "अज्ञात त्रुटि",
        network: "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।",
        server: "सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।"
      }
    }
  }
};
